import { useEffect as e, useState as t } from "react";
//#region src/components/Header/mobile/useMediaQuery.ts
function n(n) {
	let [r, i] = t(!1);
	return e(() => {
		let e = window.matchMedia(n), t = () => i(e.matches);
		return t(), e.addEventListener("change", t), () => e.removeEventListener("change", t);
	}, [n]), r;
}
//#endregion
export { n as useMediaQuery };
